import React from 'react';
import MobileBottomNav from "../components/common/MobileBottomNav";

const RefundPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 pb-16 lg:pb-0">
      <h1 className="text-3xl font-bold text-center mb-6">
        Refund Policy - Ducktail
      </h1>
      <div className="max-w-2xl mx-auto">
        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">Cancellation of Subscription</h2>
            <p className="text-gray-700">
              Once a subscription is initiated, no refunds will be provided for its cancellation, whether it is done voluntarily by the Construction Companies or forced by Ducktail.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Forced Cancellation</h2>
            <p className="text-gray-700">
              In the event of a forced cancellation of a subscription by Ducktail, such as due to a violation of terms of service or other valid reasons determined by Ducktail, no refunds will be issued to the Construction Companies.
            </p>
          </div>
        </div>
      </div>
      <MobileBottomNav />
    </div>
  );
};

export default RefundPolicy;
